'use strict';

angular.module('contentful')
.controller('AssetListActionsController', ['$scope', '$controller', function AssetListActionsController ($scope, $controller) {
  $controller('ListActionsController', {
    $scope: $scope,
    entityType: 'Asset'
  });
}]);



// WEBPACK FOOTER //
// ./src/javascripts/components/tabs/asset_list/asset_list_actions_controller.js